import React from "react";

// Upgraded luxe diamond + star sparkles. Larger, more varied, pink+gold palette.
const items = Array.from({ length: 40 }).map((_, i) => {
  const kind = i % 3; // 0 = star, 1 = diamond, 2 = dot
  const color = i % 4 === 0 ? "#FFD9A8" : i % 4 === 1 ? "#FFB5D3" : i % 4 === 2 ? "#FF1493" : "#F5EFE8";
  return {
    id: i,
    kind,
    color,
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: 3 + Math.random() * 7,
    delay: Math.random() * 4,
    duration: 2 + Math.random() * 4,
  };
});

function Shape({ kind, color }) {
  if (kind === 0) {
    // 4-point star
    return (
      <svg viewBox="0 0 24 24" fill="none" width="100%" height="100%">
        <path
          d="M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z"
          fill={color}
          opacity="0.92"
        />
      </svg>
    );
  }
  if (kind === 1) {
    // Diamond gem
    return (
      <svg viewBox="0 0 24 24" fill="none" width="100%" height="100%">
        <path
          d="M12 2 L19 9 L12 22 L5 9 Z M12 2 L5 9 L19 9 Z"
          fill={color}
          opacity="0.85"
          stroke={color}
          strokeWidth="0.5"
        />
        <path d="M12 2 L9 9 L12 22 L15 9 Z" fill="white" opacity="0.3" />
      </svg>
    );
  }
  // glowing dot
  return (
    <svg viewBox="0 0 24 24" width="100%" height="100%">
      <circle cx="12" cy="12" r="4" fill={color} opacity="0.9" />
    </svg>
  );
}

export default function Sparkles({ className = "", density = 1 }) {
  const filtered = density < 1 ? items.slice(0, Math.floor(items.length * density)) : items;
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      {filtered.map((s) => (
        <div
          key={s.id}
          className="absolute animate-twinkle"
          style={{
            left: `${s.x}%`,
            top: `${s.y}%`,
            width: `${s.size * 4}px`,
            height: `${s.size * 4}px`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
            filter: `drop-shadow(0 0 ${s.size * 2}px ${s.color})`,
          }}
        >
          <Shape kind={s.kind} color={s.color} />
        </div>
      ))}
    </div>
  );
}
